import { Avatar, Button, Heading, IconButton, Menu, MenuButton, MenuDivider, MenuItem, MenuList, Stack, Text } from "@chakra-ui/react";

import { AiFillQuestionCircle } from "react-icons/ai";
import { BiCheck, BiError, BiWindows } from "react-icons/bi";
import { BsArrowLeft, BsArrowRight, BsFolderFill } from "react-icons/bs";
import { FaFolderPlus, FaPowerOff, FaUserAlt } from 'react-icons/fa';
import { GiWallet } from 'react-icons/gi';
import { IoMdNotifications, IoMdSettings } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate,Link as ReactLink } from 'react-router-dom';
import { openSidebar, closeSidebar } from "../../reducers/themeReducer";
// import { logout } from "../../reducers/usersReducer";

export default function Navbar() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const theme = useSelector((state: any) => state.theme.value);
    const user = useSelector((state: any) => state.user.value);
    const displayName = user?.fullName || user?.full_name || user?.name || user?.email || 'Guest';

    // useEffect(() => {
    //     dispatch(closeSidebar())
    // }, []);

    function toggleSidebar() {
        if (theme?.sidebarClosed) {
            dispatch(openSidebar());
        } else {
            dispatch(closeSidebar())
        }
    }

    function Logout() {
        // dispatch(logout())
        navigate('/logout');
    }

    return (
        <Stack
            w={'100%'}
            position={'sticky'}
            top={0}
            zIndex={20}
            direction={'row'}
            border={'1px solid gray.100'}
            bg={'white'}
            boxShadow={'base'}
            justify={'space-between'}
            align={'center'}
        >
            <Stack
                ms={3}
                direction={"row"}
                spacing={-4}
            >
                <IconButton
                    aria-label="Collapse"
                    onClick={toggleSidebar}
                    transition={'0.3s ease-in-out'}
                    icon={theme?.sidebarClosed ? <BsArrowRight /> : <BsArrowLeft />}
                />
                <Stack spacing={0} ps={10}>
                    <Heading fontSize={'md'}>Dashboard</Heading>
                    <Text fontSize={'sm'}>Pages / Dashboard</Text>
                </Stack>
            </Stack>
            <Stack
                direction={'row'}
                align={'center'}
                p={4}
                spacing={4}
            >
                <Stack direction={'row'} align={'center'} justify={'center'} spacing={4} me={8}>
                    <Avatar
                        size={'md'}
                        name={displayName}
                        src={user?.profile_picture || undefined}
                    />
                    <Stack spacing={0}>
                        <Text fontStyle={'italic'} color={'gray.400'} fontSize={'sm'}>Welcome</Text>
                        <Text fontWeight={'bold'} fontSize={'sm'}>{displayName}</Text>
                    </Stack>
                </Stack>
                <IconButton
                    aria-label="Help"
                    icon={<AiFillQuestionCircle />}
                    w={'10px'}
                    h={'20px'}
                    bg={'transparent'}
                    _hover={{ bg: 'transparent' }}
                    _active={{ bg: 'transparent' }}
                />
                <Menu>
                    <MenuButton
                        as={Button}
                        aria-label="Notifications"
                        rounded={'full'}
                        cursor={'pointer'}
                        bg={'transparent'}
                        _hover={{ bg: 'transparent' }}
                        _active={{ bg: 'transparent' }}
                    >
                        <IoMdNotifications size={20} />
                    </MenuButton>
                    <MenuList>
                        <MenuItem
                            w={'full'}
                            as={Stack}
                            direction={'row'}
                            align={'center'}
                            justify={'space-between'}
                        >
                            <BiError color={'#a83232'} />
                            <Text>6 Documents Errored While Processing.</Text>
                        </MenuItem>
                        <MenuItem
                            w={'full'}
                            as={Stack}
                            direction={'row'}
                            align={'center'}
                            justify={'space-between'}
                        >
                            <BiCheck color={'#32a84a'} />
                            <Text>6 Documents Errored While Processing.</Text>
                        </MenuItem>
                        <MenuDivider />
                        <MenuItem as={Button} variant={'ghost'} textAlign={'center'} color={'blue.400'}>View All</MenuItem>
                    </MenuList>
                </Menu>
                <Menu >
                    <MenuButton
                        as={Button}
                        aria-label="Settings"
                        rounded={'full'}
                        cursor={'pointer'}
                        bg={'transparent'}
                        _hover={{ bg: 'transparent' }}
                        _active={{ bg: 'transparent' }}
                        m={0}
                        ps={0}
                    >
                        <IoMdSettings size={20} />
                    </MenuButton>
                    <MenuList position={'relative'} zIndex={99999}>
                        <MenuItem
                            mt={-2}
                            gap={6}
                            icon={<BiWindows />}
                            flexDirection={'row-reverse'}
                            textAlign={'end'}
                            borderBottom={'1px'}
                            borderBottomColor={'gray.100'}
                            py={3}
                            as={ReactLink}
                            to={'/practice/dashboard'}
                        >
                            <Text fontSize={'sm'}>Practice Management</Text>
                        </MenuItem>
                        <MenuItem
                            gap={6}
                            icon={<BsFolderFill />}
                            flexDirection={'row-reverse'}
                            textAlign={'end'}
                            borderBottom={'1px'}
                            borderBottomColor={'gray.100'}
                            py={3}
                            as={ReactLink}
                            to={'/business/profile'}
                        >
                            <Text fontSize={'sm'}>Business Profile</Text>
                        </MenuItem>
                        <MenuItem
                            gap={6}
                            icon={<FaFolderPlus />}
                            flexDirection={'row-reverse'}
                            textAlign={'end'}
                            borderBottom={'1px'}
                            borderBottomColor={'gray.100'}
                            py={3}
                            as={ReactLink}
                            to={'/business/add'}
                        >
                            <Text fontSize={'sm'}>Add New Business</Text>
                        </MenuItem>
                        <MenuItem
                            gap={6}
                            icon={<FaUserAlt />}
                            flexDirection={'row-reverse'}
                            textAlign={'end'}
                            borderBottom={'1px'}
                            borderBottomColor={'gray.100'}
                            py={3}
                            as={ReactLink}
                            to={'/profile'}
                        >
                            <Text fontSize={'sm'}>User Profile</Text>
                        </MenuItem>
                        <MenuItem
                            gap={6}
                            icon={<GiWallet />}
                            flexDirection={'row-reverse'}
                            textAlign={'end'}
                            borderBottom={'1px'}
                            borderBottomColor={'gray.100'}
                            py={3}
                            as={ReactLink}
                            to={'/billing'}
                        >
                            <Text fontSize={'sm'}>Subscription & Billing</Text>
                        </MenuItem>
                        <MenuItem
                            gap={6}
                            icon={<FaPowerOff />}
                            flexDirection={'row-reverse'}
                            textAlign={'end'}
                            borderBottom={'1px'}
                            borderBottomColor={'gray.100'}
                            py={3}
                            color={'red.400'}
                            mb={-2}
                            onClick={Logout}
                        >
                            <Text fontSize={'sm'}>Logout</Text>
                        </MenuItem>
                    </MenuList>
                </Menu>
            </Stack>
        </Stack>
    )
}